<template>
  <div>
    <main-page-title/>
    <category-list v-model="filters" />
    <course-list v-if="allCourses" :courses="allCourses" :filters="filters" />
    <main-page-institute-list />
    <feedback/>
  </div>
</template>

<script>

import MainPageTitle from "../components/MainPageTitle.vue";
import CourseList from "../components/course/CourseList.vue";
import MainPageInstituteList from "../components/MainPageInstituteList.vue";
import Feedback from "../components/Feedback.vue";
import CategoryList from "../components/course/CategoryList.vue";
import {eventBus} from "../main";
import {mapGetters} from "vuex";
export default {
  name: "MainPage",
  components: {CategoryList, Feedback, MainPageInstituteList, CourseList, MainPageTitle},
  data() {
    return {
      filters: {
        categories: [],
        title: null
      }
    }
  },
  computed: {
    ...mapGetters(['allCourses'])
  },
  mounted() {
    eventBus.$on('filters:clear', () => {
      this.filters = {
        categories: [],
        title: null
      }
    })
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Главная',
    // all titles will be injected into this template
    titleTemplate: '%s | Универсариум'
  }
}
</script>